import { protectedApi } from '@api/index';
import { formatApiResponse } from '@utils/helpers';
import { APIdateFormat } from '@utils/dates';

export async function getCallsListApi(page, limit, sorting, filter, isIssue) {
  // date Filter
  let dateFilter =
    filter.startDate && filter.endDate
      ? `&start_date=${APIdateFormat(
          filter.startDate
        )}&end_date=${APIdateFormat(filter.endDate)}`
      : '';
  // category filter
  let categoryFilter = filter.category.length
    ? `&category=${filter.category.join(',')}`
    : '';
  // status filter
  let statusFilter = filter.callStatus.length
    ? `&call_status=${filter.callStatus.join(',')}`
    : '';

  let sourceFilter = filter.source.length
    ? `&type=${filter.source.join(',')}`
    : '';

  let followUpFilter = filter.followUp.length
    ? `&followup=${filter.followUp.join(',')}`
    : '';
  
    let patientTypeFilter = filter.patientType.length
    ? `&patient_type=${filter.patientType.join(',')}`
    : '';

  //  text search filter
  let textSearchFilter = filter.search.length ? `&search=${filter.search}` : '';

  let clinicIdFilter = filter.clinic_id ? `&clinic_id=${filter.clinic_id}` : '';

  let filter_str = `${dateFilter}${textSearchFilter}${statusFilter}${categoryFilter}${sourceFilter}${followUpFilter}${clinicIdFilter}${patientTypeFilter}`;
  let sort = sorting.sort ? `&sort=${sorting.sort}&order=${sorting.order}` : '';

  const endpoint = `/calls/?page=${page}${sort}&limit=${limit}${filter_str}&is_issue=${isIssue}`;
  try {
    const res = await protectedApi.get(endpoint);
    return formatApiResponse(res);
  } catch (e) {
    console.error('getCallsListApi.catch', e);
    return formatApiResponse(e);
  }
}

export async function getIndividualCallTranscriptApi(call_id) {
  try {
    const res = await protectedApi.get(`/calls/transcript/${call_id}`);
    return formatApiResponse(res);
  } catch (e) {
    console.error('getIndividualCallTranscriptApi.catch', e);
    return formatApiResponse(e);
  }
}

export async function getIndividualCallRecordingApi(call_id) {
  try {
    const res = await protectedApi.get(`/calls/recording/${call_id}`);
    return formatApiResponse(res);
  } catch (e) {
    console.error('getIndividualCallRecordingApi.catch', e);
    return formatApiResponse(e);
  }
}

export async function getIndividualCallRailDetailApi(lead_id) {
  try {
    const res = await protectedApi.get(`/calls/${lead_id}`);
    return formatApiResponse(res);
  } catch (e) {
    console.error('getIndividualCallRailDetailApi.catch', e);
    return formatApiResponse(e);
  }
}

export async function putIndividualCallRailDetailApi(lead_id, data) {
  try {
    const res = await protectedApi.put(`/calls/${lead_id}/`, data);
    return formatApiResponse(res);
  } catch (e) {
    console.error('putIndividualCallRailDetailApi.catch', e);
    return formatApiResponse(e);
  }
}

export async function getIndividualNotes(lead_id,source) {
  const endpoint = `/calls/notes/?lead_id=${lead_id}&source=${source}`;
  try {
    const res = await protectedApi.get(endpoint);
    return formatApiResponse(res);
  } catch (e) {
    console.error('getIndividualNotes.catch', e);
    return formatApiResponse(e);
  }
}

export const addNotes = async (data) => {
  const endpoint = `/calls/notes/`;
  try {
    const response = await protectedApi.post(endpoint, data);
    return formatApiResponse(response);
  } catch (error) {
    return formatApiResponse(error);
  }
};

export async function getIndividualMessages(lead_id) {
  try {
    const res = await protectedApi.get(`/calls/messages/${lead_id}/`);
    return formatApiResponse(res);
  } catch (e) {
    console.error('getIndividualMessages.catch', e);
    return formatApiResponse(e);
  }
}

export const addMessages = async (lead_id, data) => {
  const endpoint = `/calls/messages/${lead_id}/`;
  try {
    const response = await protectedApi.post(endpoint, data);
    return formatApiResponse(response);
  } catch (error) {
    return formatApiResponse(error);
  }
};

export async function getMasterCategoryList() {
  try {
    const res = await protectedApi.get(`/calls/master-category-reasons/`);
    return formatApiResponse(res);
  } catch (e) {
    console.error('getMasterCategoryList.catch', e);
    return formatApiResponse(e);
  }
}

export async function getPhrasesAPI() {
  const endpoint = `/calls/phrases/`;
  try {
    const res = await protectedApi.get(endpoint);
    return formatApiResponse(res);
  } catch (e) {
    console.error('getIndividualCallTranscriptApi.catch', e);
    return formatApiResponse(e);
  }
}

export const createPhraseAPI = async (data) => {
  const endpoint = `/calls/phrases/`;
  try {
    const response = await protectedApi.post(endpoint,data);
    return formatApiResponse(response);
  } catch (error) {
    return formatApiResponse(error);
  }
};

export async function updatePhraseAPI(data) {
  const endpoint = `/calls/phrases/`;
  try {
    const res = await protectedApi.put(endpoint, data);
    return formatApiResponse(res);
  } catch (e) {
    console.error('putIndividualCallRailDetailApi.catch', e);
    return formatApiResponse(e);
  }
}

export async function deletePhraseAPI(phrase_id) {
  const endpoint = `/calls/phrases/?phrase_id=${phrase_id}`;
  try {
    const response = await protectedApi.delete(endpoint);
    return formatApiResponse(response);
  } catch (error) {
    return formatApiResponse(error);
  }
}


export async function downloadLeadReportPdf(page, limit, sorting, filter, isIssue) {

  let dateFilter =
    filter.startDate && filter.endDate
      ? `&start_date=${APIdateFormat(
          filter.startDate
        )}&end_date=${APIdateFormat(filter.endDate)}`
      : '';
  // category filter
  let categoryFilter = filter.category.length
    ? `&category=${filter.category.join(',')}`
    : '';
  // status filter
  let statusFilter = filter.callStatus.length
    ? `&call_status=${filter.callStatus.join(',')}`
    : '';

  let sourceFilter = filter.source.length
    ? `&type=${filter.source.join(',')}`
    : '';

  let followUpFilter = filter.followUp.length
    ? `&followup=${filter.followUp.join(',')}`
    : '';
  
    let patientTypeFilter = filter.patientType.length
    ? `&patient_type=${filter.patientType.join(',')}`
    : '';

  //  text search filter
  let textSearchFilter = filter.search.length ? `&search=${filter.search}` : '';

  let clinicIdFilter = filter.clinic_id ? `&clinic_id=${filter.clinic_id}` : '';

  let filter_str = `${dateFilter}${textSearchFilter}${statusFilter}${categoryFilter}${sourceFilter}${followUpFilter}${clinicIdFilter}${patientTypeFilter}`;
  let sort = sorting.sort ? `&sort=${sorting.sort}&order=${sorting.order}` : '';


  try {
    const res = await protectedApi.get(
    `/calls/download-leads-report?page=${page}${sort}&limit=${limit}${filter_str}&is_issue=${isIssue}`,
  
  );
    return formatApiResponse(res);
  } catch (e) {
    console.error('getDownloadLeadReportPDFApi.catch', e);
    return formatApiResponse(e);
  }
}